export default __webpack_public_path__ + "static/iphonex-reportingtools-24a672ec8e4a9746c90b3241be78cba1.png";